export default __webpack_public_path__ + "static/media/profile.fd770652.svg";